var _rect, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTotalUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.601562,
    width: 60,
    height: 60,
    rx: 16,
    fill: "url(#paint0_linear_4255_14297)",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4255_14297)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40.8271,
    cy: 26.6591,
    r: 3.40909,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.3739,
    cy: 26.6591,
    rx: 3.40909,
    ry: 3.40909,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6001 40.9773V36.2046C45.6001 33.5687 43.4633 31.4319 40.8274 31.4319V31.4319C38.1915 31.4319 36.0547 33.5687 36.0547 36.2046V40.9773",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.147 40.9773V36.2046C25.147 33.5687 23.0102 31.4319 20.3743 31.4319V31.4319C17.7384 31.4319 15.6016 33.5687 15.6016 36.2046V40.9773",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5992,
    cy: 23.0553,
    r: 3.8961,
    fill: "#03F5AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0575 42.341V34.1591C36.0575 31.1467 33.6154 28.7046 30.603 28.7046V28.7046C27.5905 28.7046 25.1484 31.1467 25.1484 34.1591V42.341",
    stroke: "#03F5AE",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4255_14297",
    x1: 9.60156,
    y1: 2,
    x2: 60.6016,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F5AE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4255_14297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(12.6016 12)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalUser);
export default __webpack_public_path__ + "static/media/totalUser.ece058be578b0ed573950ca3a8f60ca5.svg";
export { ForwardRef as ReactComponent };